const clearAgencyTwilio = function (state) {
  state.agencyTwilio = {
    id: '',
    accountSid: '',
    companyId: '',
    traceId: '',
  }
}

export default clearAgencyTwilio
